import http from '@/core/http'
import { map } from 'lodash'

const state = {
  itens: [],
  allAffiliates: [],
  totalItens: 0,
  itensContratos: [],
  parentIdAffiliate: '',
  itensReferencias: []
}

const headers = { moduloname: 'afiliados' }

const actions = {
  obterAfiliados: async ({commit}, paylaod) => {
    const result = await http.get('afiliados-pendentes', { params: paylaod })
    commit('LISTA_AFILIADOS', result.data)
    return Promise.resolve(result.data[0])
  },

  obterTodosAfiliados: async ({commit}, paylaod) => {
    const result = await http.get('afiliados/get-all-affiliates', { params: paylaod })
    commit('LISTA_TODOS_AFILIADOS', result.data)
    return Promise.resolve(result.data[0])
  },

  aprovarAfiliado: async ({commit}, payload) => {
    const result = await http.post('afiliados-pendentes', payload)
    commit('LISTA_AFILIADOS', result.data)
    return Promise.resolve(result.data[0])
  },
  editarAfiliado: async ({commit}, payload) => {
    const result = await http.put('afiliados-pendentes', payload)
    commit('LISTA_AFILIADOS', result.data)
    return Promise.resolve(result.data[0])
  },

  reprovarAfiliado: async ({commit}, payload) => {
    const result = await http.delete('afiliados-pendentes', { params: payload  })
    commit('LISTA_AFILIADOS', result.data)
    return Promise.resolve(result.data[0])
  },

  obterContratosCadastrados: async ({commit}, payload) => {
    const result = await http.get('afiliados-pendentes/contratos', { params: { affiliateId: payload }, headers })
    commit('LISTA_CONTRATOS', result.data.data)
    return Promise.resolve(result.data[0])
  },

  setListaContratosAdicionado: async ({commit}, payload) => {
    commit('ADD_CONTRATO', payload)
  },

  setParentIdAffiliate: async ({commit}, payload) => {
    commit('ADD_PARENT_ID_AFFILIATE', payload)
  },

  removerContrato: async ({commit}, payload) => {
    commit('REMOVE_CONTRATO', payload)
  },

  obterReferenciasCadastrados: async ({commit}, payload) => {
    const result = await http.get('afiliados-pendentes/referencias', { params: { affiliateId: payload }, headers })
    commit('LISTA_REFERENCIA', result.data.data)
    return Promise.resolve(result.data[0])
  },

  setListaReferenciasAdicionado: async ({commit}, payload) => {
    commit('ADD_REFERENCIA', payload)
  },

  removerReferencia: async ({commit}, payload) => {
    commit('REMOVE_REFERENCIA', payload)
  },

  limparItem: async ({commit}) => {
    commit('LIMPAR_ITEMS')
  }
}

const mutations = {
  'LISTA_AFILIADOS' (state, payload) {
    state.itens = payload[0]
    state.totalItens = payload[1]
  },

  'LISTA_TODOS_AFILIADOS' (state, payload) {
    state.allAffiliates = map(payload.resultMap, (v) => ({
      id: v.id,
      name: `${v.name} (${v.id})`
    }))
  },

  'LISTA_CONTRATOS' (state, payload) {
    state.itensContratos = payload
  },
  
  'ADD_CONTRATO' (state, payload) {
    state.itensContratos.push(payload)
  },

  'ADD_PARENT_ID_AFFILIATE' (state, payload) {
    state.parentIdAffiliate = payload
  },

  'REMOVE_CONTRATO' (state, payload) {
    state.itensContratos.splice(payload, 1)
  },

  'LISTA_REFERENCIA' (state, payload) {
    state.itensReferencias = payload
  },
  
  'ADD_REFERENCIA' (state, payload) {
    state.itensReferencias.push(payload)
  },

  'REMOVE_REFERENCIA' (state, payload) {
    state.itensReferencias.splice(payload, 1)
  },

  'LIMPAR_ITEMS' (state) {
    state.itensContratos = [],
    state.itensReferencias = [],
    state.allAffiliates = []
  }
}

const getters = {
  listaItens: state => state.itens,
  listaAllAffiliates: state => state.allAffiliates,
  totalItens: state => state.totalItens,
  itensContratos: state => state.itensContratos,
  itensReferencias: state => state.itensReferencias,
  getParentIdAffiliate: state => state.parentIdAffiliate,
}

export default { namespaced: true, state, actions, mutations, getters }